import {createActionsWorkflowsRoutes} from '@github-ui/actions-workflows/routes/create-actions-workflows-routes'
import {lazyActionsWorkflowsRouteComponents} from '@github-ui/actions-workflows/routes/lazy-route-components'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- The repo app composes the existing commits app routes during incremental onboarding.
import {createCommitsRoutes} from '@github-ui/commits/routes/create-commits-routes'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- The repo app composes the existing commits app routes during incremental onboarding.
import {lazyCommitsRouteComponents} from '@github-ui/commits/routes/lazy-route-components'
import {createIssuesRoutes} from '@github-ui/issues/routes/create-issues-routes'
import {lazyIssuesRouteComponents} from '@github-ui/issues/routes/lazy-route-components'
import {createPullRequestsRoutes} from '@github-ui/pull-requests/routes/create-pull-requests-routes'
import {lazyPullRequestsRouteComponents} from '@github-ui/pull-requests/routes/lazy-route-components'
import {registerCopilotApp} from '@github-ui/copilot-browser-latency/copilot-app-root'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import {createRepoAgentsRoutes} from '@github-ui/repo-agents/routes/create-repo-agents-routes'
import {lazyRepoAgentsRouteComponents} from '@github-ui/repo-agents/routes/lazy-route-components'
import {repoLayoutRoute} from './routes/repo-layout-route'
import {withRepoRouteHandle} from './routes/repo-route-handle'
import {RepoLayout} from './pages/RepoLayout'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {RepoErrorBoundary} from './components/RepoErrorBoundary'
import {createReleasesRoutes} from '@github-ui/releases/routes/create-releases-routes'
import {lazyReleasesRouteComponents} from '@github-ui/releases/routes/lazy-route-components'

const actionsWorkflowsRoutes = ({
  nativeCachesEnabled,
  nativeRunnersEnabled,
}: {
  nativeCachesEnabled: boolean
  nativeRunnersEnabled: boolean
}) => {
  if (!isFeatureEnabled('actions_workflows_react_toggle')) {
    return []
  }
  return createActionsWorkflowsRoutes(repoAppBuilder, lazyActionsWorkflowsRouteComponents, {
    nativeCachesEnabled,
    nativeRunnersEnabled,
  })
}

export const repoApp = repoAppBuilder.createDataRouterAppFromRoutes(params => [
  repoLayoutRoute.toRoute({
    Component: RepoLayout,
    errorBoundary: {override: RepoErrorBoundary},
    children: [
      ...createReleasesRoutes(repoAppBuilder, lazyReleasesRouteComponents),
      ...withRepoRouteHandle(createRepoAgentsRoutes(repoAppBuilder, lazyRepoAgentsRouteComponents), {
        repoSubAppName: 'repo-agents',
        selectedLink: 'repo_agents',
      }),
      ...withRepoRouteHandle(createIssuesRoutes(repoAppBuilder, lazyIssuesRouteComponents), {
        repoSubAppName: 'issues',
        selectedLink: 'repo_issues',
      }),
      ...withRepoRouteHandle(createPullRequestsRoutes(repoAppBuilder, params, lazyPullRequestsRouteComponents), {
        repoSubAppName: 'pull-requests',
        selectedLink: 'repo_pulls',
      }),
      ...withRepoRouteHandle(
        actionsWorkflowsRoutes({
          nativeCachesEnabled: isFeatureEnabled('actions_caches_react_view'),
          nativeRunnersEnabled: isFeatureEnabled('actions_runners_react_view'),
        }),
        {
          repoSubAppName: 'actions-workflows',
          selectedLink: 'repo_actions',
        },
      ),
      ...withRepoRouteHandle(createCommitsRoutes(repoAppBuilder, lazyCommitsRouteComponents), {
        repoSubAppName: 'commits',
        selectedLink: 'repo_commits',
      }),
    ],
  }),
])

registerCopilotApp(repoApp)
